module.exports = __webpack_public_path__ + "static/media/ic-check-circle-off.c15b6923.svg";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/truebalance/images/ic-check-circle-off.svg
// module id = 1357
// module chunks = 0